/* eslint-disable global-require */
const createHistory = require('history').createBrowserHistory

export const history = createHistory()

window.reactHistory = history

export default { history }
